import { Box } from "@mui/material";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

const FormattedText = ({ content, sx }: { content: string; sx?: any }) => {
  return (
    <Box>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...props }) => <h1 style={styles.headingStyle} {...props} />,
          h2: ({ node, ...props }) => <h2 style={styles.headingStyle} {...props} />,
          h3: ({ node, ...props }) => <h3 style={styles.headingStyle} {...props} />,
          h4: ({ node, ...props }) => <h4 style={styles.headingStyle} {...props} />,
          h5: ({ node, ...props }) => <h5 style={styles.headingStyle} {...props} />,
          h6: ({ node, ...props }) => <h6 style={styles.headingStyle} {...props} />,
          p: ({ node, ...props }) => <p style={styles.baseStyle} {...props} />,
          strong: ({ node, ...props }) => <strong style={styles.headingStyle} {...props} />,
          code: ({ inline, ...props }: { inline?: boolean } & React.ComponentPropsWithoutRef<"code">) =>
            inline ? (
              <code style={{ ...styles.baseStyle, background: "#f4f4f4", padding: "2px 4px" }} {...props} />
            ) : (
              <pre style={{ ...styles.baseStyle, background: "#1e1e1e", padding: "10px" }} {...props} />
            ),
          ul: ({ node, ...props }) => <ul style={styles.unorderedListStyle} {...props} />,
          ol: ({ node, ...props }) => <ol style={styles.orderedListStyle} {...props} />,
          li: ({ node, ...props }) => <li style={{ ...styles.baseStyle, marginLeft: "16px" }} {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};

export default FormattedText;

const baseStyle = {
  color: "var(--Dark---800, #414141)",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  margin: "8px 0",
};

const styles = {
  baseStyle,
  headingStyle: {
    color: "var(--titles-paragraphs-text-dark, #19213D)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "130%",
    margin: "16px 0",
  },
  orderedListStyle: {
    ...baseStyle,
    marginLeft: "16px",
    listStyleType: "decimal",
  },
  unorderedListStyle: {
    ...baseStyle,
    marginLeft: "16px",
    listStyleType: "disc",
  },
};
